import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Layout, PageHeader } from 'antd'
import BreadCrumb from '~/components/breadCrumb'
import DataTable from '~/components/dataTable'
import CreationModal from 'components/creationModal/modal'
import { getColumns } from './columns'
import {
	setShowModal,
	listDatabases,
	createDatabase,
	deleteDatabase,
} from '../../states/modules/internalDatabase'

import MainLayout from '~/components/mainLayout'

// TODO: rename
const InternalDatabase = () => {
	const dispatch = useDispatch()
	const history = useHistory()
	const {
		data: internalDatabase,
		loading,
		pages,
		showModal,
	} = useSelector(({ internalDatabase }) => internalDatabase)

	const handleCreate = (title) => {
		dispatch(setShowModal(false))
		dispatch(createDatabase({ title, history }))
	}

	const handleToGo = (database) => {
		history.push({
			pathname: `/internaldatabases/${database.id}`,
		})
	}

	const handleCancel = () => {
		dispatch(setShowModal(false))
	}

	const handleShowModal = () => {
		dispatch(setShowModal(true))
	}

	const handleDeleteDatabase = (database) =>
		dispatch(deleteDatabase({ id: database.id, pages }))

	const getDatabases = ({ page, perPage, search }) => {
		dispatch(listDatabases({ page, perPage, search }))
	}

	const handleSearch = ({ page, perPage, search }) =>
		dispatch(listDatabases({ page, perPage, search }))

	useEffect(() => {
		dispatch(listDatabases())
	}, [dispatch])

	return (
		<MainLayout selectedKey={'new-databases'}>
			<Layout style={{ backgroundColor: '#fff' }}>
				<PageHeader>
					<BreadCrumb current="Banco de dados" />
				</PageHeader>
				<Layout style={{ backgroundColor: '#fff' }}>
					<CreationModal
						title="Novo banco de dados"
						handleCancel={handleCancel}
						handleCreate={handleCreate}
						showModal={showModal}
					/>
					<DataTable
						columns={getColumns(handleToGo, handleDeleteDatabase)}
						dataSource={internalDatabase}
						pages={pages}
						onChangePageNumber={getDatabases}
						onSearch={handleSearch}
						onClickButton={handleShowModal}
						textButton="Novo Banco de Dados"
						placeholderNoData={!loading ? 'Nenhum dado encontrado' : ''}
						loading={loading}
					/>
				</Layout>
			</Layout>
		</MainLayout>
	)
}

export default InternalDatabase
